import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';

@Component({
    selector: 'app-activate',
    templateUrl: './activate.component.html',
    styleUrls: ['./activate.component.css'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class ActivateComponent implements OnInit {
  private _route = inject(ActivatedRoute);
  private _account = inject(AccountService);

  token: string;
  activated: boolean = false;
  error: boolean = false;

  ngOnInit(): void {

    this._route.queryParamMap.subscribe(params => {
      this.token = params.get('token');
    });

    if(this.token)
    {
      this.submit();
    }
    else
    {
      this.activated = false;
      this.error = true;
    }
  }

  private submit()
  {
    this._account.confirm(this.token).subscribe(
      {
        next: (data) => {
          this.activated = true;
        },
        error: (error) => {
          this.activated = false;
          this.error = true;
        }
      }
    );
  }

}
